var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2,
    fill: "url(#paint0_linear_118_53)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2,
    fill: "url(#paint1_linear_118_53)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2,
    fill: "url(#paint2_linear_118_53)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "url(#paint3_linear_118_53)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2,
    fill: "url(#paint4_linear_118_53)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2,
    fill: "url(#paint5_linear_118_53)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2,
    fill: "url(#paint6_linear_118_53)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2,
    fill: "url(#paint7_linear_118_53)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2,
    fill: "url(#paint8_linear_118_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_53",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_53",
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_53",
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_53",
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_53",
    x1: 6,
    y1: 10,
    x2: 6,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_53",
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_118_53",
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_118_53",
    x1: 6,
    y1: 16,
    x2: 6,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_118_53",
    x1: 18,
    y1: 16,
    x2: 18,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/More-icon.f3bd2d056cd9692d19d183c619def850.svg";
export { ForwardRef as ReactComponent };